import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "full",
  "title": "Показатели ЦУР 4",
  "lead": "Обеспечение всеохватного и справедливого качественного образования и поощрение возможностей обучения на протяжении всей жизни для всех"
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {IndicatorRow, IndicatorSection, IndicatorTable, TargetFourLogo, ThemeLabel, Title} = _components;
  if (!IndicatorRow) _missingMdxReference("IndicatorRow", true);
  if (!IndicatorSection) _missingMdxReference("IndicatorSection", true);
  if (!IndicatorTable) _missingMdxReference("IndicatorTable", true);
  if (!TargetFourLogo) _missingMdxReference("TargetFourLogo", true);
  if (!ThemeLabel) _missingMdxReference("ThemeLabel", true);
  if (!Title) _missingMdxReference("Title", true);
  return _jsxs(_Fragment, {
    children: [_jsx(TargetFourLogo, {}), "\n", _jsx(Title, {
      children: "Показатели ЦУР 4"
    }), "\n", _jsx(_components.p, {
      children: "Обеспечение всеохватного и справедливого качественного образования и поощрение возможностей обучения на протяжении всей жизни для всех"
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "задача-41",
        children: "Задача 4.1"
      }), _jsxs(_components.p, {
        children: ["К 2030 году обеспечить, чтобы все девочки и мальчики завершали получение бесплатного, равноправного и качественного начального и среднего образования, позволяющего добиться востребованных и эффективных результатов обучения. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=236",
          children: "См. последнюю версию главы Доклада ВДМО"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "4.1.0",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.0",
          children: [_jsx(_components.p, {
            children: "Доля детей и молодежи, подготовленных к будущему, в разбивке по полу "
          }), _jsx(ThemeLabel, {
            theme: "learning",
            id: "4.1.0"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.1.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.1",
          global: true,
          children: [_jsx(_components.p, {
            children: "Процент детей и молодежи: (a) в 2-3 классах; (б) в конце начальной школы и (в) в конце неполного среднего образования, которые достигли хотя бы минимального уровня профессиональной подготовки в (i) чтении и (ii) математике, с распределением по полу"
          }), _jsx(ThemeLabel, {
            theme: "learning",
            id: "4.1.1a"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.1.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.2",
          global: true,
          children: _jsx(_components.p, {
            children: "Коэффициент завершения (начальное образование, неполное и полное среднее образование)"
          })
        }), _jsx(IndicatorRow, {
          id: "4.1.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.3",
          children: _jsx(_components.p, {
            children: "Общий коэффициент приема в последний класс (начальное образование, неполное среднее образование)"
          })
        }), _jsxs(IndicatorRow, {
          id: "4.1.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.4",
          children: [_jsx(_components.p, {
            children: "Доля детей, не посещающих школу (1 год до начала обучения, начальное образование, неполное среднее образование, полное среднее образование)"
          }), _jsx(ThemeLabel, {
            theme: "access",
            id: "4.1.4"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.1.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.5",
          children: [_jsx(_components.p, {
            children: "Доля детей старше установленного для данного класса возраста (начальное образование, неполное среднее образование)"
          }), _jsx(ThemeLabel, {
            theme: "access",
            id: "4.1.5"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.1.6",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.6",
          children: [_jsx(_components.p, {
            children: "Проведение национальной репрезентативной оценки результатов обучения (a) во 2 или 3 классе; (b) в конце начальной школы; и (c) в конце неполной среднее школы."
          }), _jsx(ThemeLabel, {
            theme: "access",
            id: "4.1.6"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.1.7",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.7",
          children: _jsx(_components.p, {
            children: "Количество лет i) бесплатного и ii) обязательного начального и среднего образования, гарантированных законодательством"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "задача-42",
        children: "Задача 4.2"
      }), _jsxs(_components.p, {
        children: ["К 2030 году обеспечить, чтобы все девочки и мальчики имели доступ к качественным системам развития, ухода и дошкольного обучения детей младшего возраста, с тем чтобы они были готовы к получению начального образования. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=253",
          children: "См. последнюю версию главы Доклада ВДМО"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsx(IndicatorRow, {
          id: "4.2.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.1",
          global: true,
          children: _jsx(_components.p, {
            children: "Доля детей в возрасте 24–59 месяцев, которые развиваются без отклонений в плане здоровья, обучения и психосоциального благополучия, в разбивке по полу"
          })
        }), _jsxs(IndicatorRow, {
          id: "4.2.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.2",
          global: true,
          children: [_jsx(_components.p, {
            children: "Уровень участия в организованных видах обучения (за один год до достижения официального возраста поступления в школу) в разбивке по полу"
          }), _jsx(ThemeLabel, {
            theme: "access",
            id: "4.2.2"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.2.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.3",
          children: _jsx(_components.p, {
            children: "Доля детей в возрасте до 5 лет, находящихся в благоприятной домашней обстановке, стимулирующей развитие"
          })
        }), _jsx(IndicatorRow, {
          id: "4.2.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.4",
          children: _jsx(_components.p, {
            children: "Чистый коэффициент охвата в a) дошкольном образовании и b) программах развития детей младшего возраста"
          })
        }), _jsx(IndicatorRow, {
          id: "4.2.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.5",
          children: _jsx(_components.p, {
            children: "Количество лет i) бесплатного и ii) обязательного дошкольного образования, гарантированных законодательством"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "задача-43",
        children: "Задача 4.3"
      }), _jsxs(_components.p, {
        children: ["К 2030 году обеспечить для всех женщин и мужчин равный доступ к недорогому и качественному профессионально-техническому и высшему образованию, в том числе университетскому образованию. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=263",
          children: "См. последнюю версию главы Доклада ВДМО"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsx(IndicatorRow, {
          id: "4.3.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.3/i4.3.1",
          global: true,
          children: _jsx(_components.p, {
            children: "Уровень участия молодых и взрослых людей в формальных и неформальных видах обучения и профессиональной подготовки в последние 12 месяцев в разбивке по полу "
          })
        }), _jsx(IndicatorRow, {
          id: "4.3.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.3/i4.3.2",
          children: _jsx(_components.p, {
            children: "Общий коэффициент охвата высшим образованием, в разбивке по полу"
          })
        }), _jsx(IndicatorRow, {
          id: "4.3.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.3/i4.3.3",
          children: _jsx(_components.p, {
            children: "Уровень участия молодежи в профессионально-техническом образовании (в возрасте 15-24 лет), в разбивке по полу"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "задача-44",
        children: "Задача 4.4"
      }), _jsxs(_components.p, {
        children: ["К 2030 году существенно увеличить число молодых и взрослых людей, обладающих востребованными навыками, в том числе профессионально-техническими навыками, для трудоустройства, получения достойной работы и занятий предпринимательской деятельностью. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=271",
          children: "См. последнюю версию главы Доклада ВДМО"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsx(IndicatorRow, {
          id: "4.4.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.4/i4.4.1",
          global: true,
          children: _jsx(_components.p, {
            children: "Доля молодых и взрослых людей, обладающих навыками в области информационно-коммуникационных технологий, в разбивке по видам навыков "
          })
        }), _jsx(IndicatorRow, {
          id: "4.4.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.4/i4.4.2",
          children: _jsx(_components.p, {
            children: "Доля молодежи и взрослых, достигших, по крайней мере, минимального уровня цифровой грамотности"
          })
        }), _jsx(IndicatorRow, {
          id: "4.4.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.4/i4.4.3",
          children: _jsx(_components.p, {
            children: "Уровень образования молодежи/взрослых в разбивке по возрастным группам и уровню образования"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "задача-45",
        children: "Задача 4.5"
      }), _jsxs(_components.p, {
        children: ["К 2030 году ликвидировать гендерное неравенство в сфере образования и обеспечить равный доступ к образованию и профессионально-технической подготовке всех уровней для уязвимых групп населения, в том числе инвалидов, представителей коренных народов и детей, находящихся в уязвимом положении. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=281",
          children: "См. последнюю версию главы Доклада ВДМО"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "4.5.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i.4.5.1",
          global: true,
          children: [_jsx(_components.p, {
            children: "Индекс равенства (женщины/мужчины, сельское/ городское население, нижний/верхний квантиль по благосостоянию и другие показатели, такие как статус инвалида, принадлежность к коренному и затронутому конфликтом населению в момент поступления данных) по всем показателям в этом списке, которые можно разукрупнить"
          }), _jsx(ThemeLabel, {
            theme: "equity",
            id: "4.5.1"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.5.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.2",
          children: _jsx(_components.p, {
            children: "Доля учащихся в а) младших классах, б) в конце начального и в) в конце неполного среднего образования, у которых первый язык или язык, на котором говорят дома, является языком обучения"
          })
        }), _jsx(IndicatorRow, {
          id: "4.5.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.3",
          children: _jsx(_components.p, {
            children: "Степень, в которой политикой, основанной на четких расчетах, предусмотрено распределение ресурсов в области образования для населения из неблагополучных групп"
          })
        }), _jsx(IndicatorRow, {
          id: "4.5.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.4",
          children: _jsx(_components.p, {
            children: "Расходы на образование одного учащегося, в разбивке по уровням образования и источникам финансирования"
          })
        }), _jsxs(IndicatorRow, {
          id: "4.5.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.5",
          children: [_jsx(_components.p, {
            children: "Доля общей помощи, выделяемая странам с низким уровнем дохода на образование"
          }), _jsx(ThemeLabel, {
            theme: "finance",
            id: "4.5.5"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.5.6",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.6",
          children: [_jsx(_components.p, {
            children: "Расходы на образование по источникам финансирования (государственные, частные, международные) в процентах от ВВП"
          }), _jsx(ThemeLabel, {
            theme: "finance",
            id: "4.5.6"
          })]
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "задача-46",
        children: "Задача 4.6"
      }), _jsxs(_components.p, {
        children: ["К 2030 году обеспечить, чтобы все молодые люди и значительная доля взрослого населения, как мужчин, так и женщин, умели читать, писать и считать. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=292",
          children: "См. последнюю версию главы Доклада ВДМО"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "4.6.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.6/i4.6.1",
          global: true,
          children: [_jsx(_components.p, {
            children: "Доля населения  в данной возрастной группе, достигшая, по меньшей мере, установленного уровня функциональной способности a) писать и читать и b) считать, в разбивке по полу"
          }), _jsx(ThemeLabel, {
            theme: "learning",
            id: "4.6.1"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.6.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.6/i4.6.2",
          children: [_jsx(_components.p, {
            children: "Уровень грамотности среди молодежи и взрослых"
          }), _jsx(ThemeLabel, {
            theme: "learning",
            id: "4.6.2"
          })]
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "задача-47",
        children: "Задача 4.7"
      }), _jsxs(_components.p, {
        children: ["К 2030 году обеспечить, чтобы все учащиеся приобретали знания и навыки, необходимые для содействия устойчивому развитию, в том числе посредством обучения по вопросам устойчивого развития и устойчивого образа жизни, прав человека, гендерного равенства, пропаганды культуры мира и ненасилия, гражданства мира и осознания ценности культурного разнообразия и вклада культуры в устойчивое развитие. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=300",
          children: "См. последнюю версию главы Доклада ВДМО"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsx(IndicatorRow, {
          id: "4.7.1",
          global: true,
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.1",
          children: _jsx(_components.p, {
            children: "Статус i) воспитания в духе всемирной гражданственности и ii) пропаганды устойчивого развития, включая гендерное равенство и права человека, на всех уровнях в a) национальной политике в сфере образования; b) учебных программах; c) программах подготовки учителей; и d) системе аттестации учащихся"
          })
        }), _jsx(IndicatorRow, {
          id: "4.7.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.2",
          children: _jsx(_components.p, {
            children: "Доля школ, предоставляющих жизненно важные навыки по вопросам ВИЧ и сексуального образования"
          })
        }), _jsx(IndicatorRow, {
          id: "4.7.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.3",
          children: _jsx(_components.p, {
            children: "Степень использования намерений \"зеленой\" политики в учебных планах"
          })
        }), _jsx(IndicatorRow, {
          id: "4.7.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.4",
          children: _jsx(_components.p, {
            children: "Доля учащихся неполной средней школы, демонстрирующих достаточное понимание проблем, связанных с глобальной гражданственностью и устойчивым развитием"
          })
        }), _jsx(IndicatorRow, {
          id: "4.7.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.5",
          children: _jsx(_components.p, {
            children: "Доля учащихся неполной средней школы, демонстрирующих достаточный уровень знаний в науке об окружающей среде и науке о Земле"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "задача-4a",
        children: "Задача 4.a"
      }), _jsxs(_components.p, {
        children: ["Создавать и совершенствовать учебные заведения, учитывающие интересы детей, особые нужды инвалидов и гендерные аспекты, и обеспечить безопасную, свободную от насилия и социальных барьеров и эффективную среду обучения для всех. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=308",
          children: "См. последнюю версию главы Доклада ВДМО"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "4.a.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.a/i4.a.1",
          global: true,
          children: [_jsx(_components.p, {
            children: "Доля школ, предлагающих основные услуги, в разбивке по типу уcлуг"
          }), _jsx(ThemeLabel, {
            theme: "quality",
            id: "4.a.1"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.a.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.a/i4.a.2",
          children: [_jsx(_components.p, {
            children: "Доля учащихся, подвергающихся буллингу в течение последних 12 месяцев в а) начальной и б) неполной средней школе"
          }), _jsx(ThemeLabel, {
            theme: "quality",
            id: "4.a.2"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.a.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.a/i4.a.3",
          children: _jsx(_components.p, {
            children: "Количество нападений на учащихся, работников образования и учебные учреждения"
          })
        }), _jsx(IndicatorRow, {
          id: "4.a.4",
          children: _jsx(_components.p, {
            children: "Доля детей, посещающих школу, получающих школьное питание"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "задача-4b",
        children: "Задача 4.b"
      }), _jsxs(_components.p, {
        children: ["К 2020 году значительно увеличить во всем мире количество стипендий, предоставляемых развивающимся странам, особенно наименее развитым странам, малым островным развивающимся государствам и африканским странам, для получения высшего образования, включая профессионально- техническое образование и обучение по вопросам информационно- коммуникационных технологий, технические, инженерные и научные программы, в развитых странах и других развивающихся странах. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=321",
          children: "См. последнюю версию главы Доклада ВДМО"
        })]
      }), _jsx(IndicatorTable, {
        children: _jsx(IndicatorRow, {
          id: "4.b.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.b/i4.b.1",
          global: true,
          children: _jsx(_components.p, {
            children: "Объем официальной помощи в целях развития, направляемой на выплату стипендий, в разбивке по отраслям и видам обучения"
          })
        })
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "задача-4c",
        children: "Задача 4.c"
      }), _jsxs(_components.p, {
        children: ["К 2030 году значительно увеличить число квалифицированных учителей, в том числе посредством международного сотрудничества в подготовке учителей в развивающихся странах, особенно в наименее развитых странах и малых островных развивающихся государствах. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=331",
          children: "См. последнюю версию главы Доклада ВДМО"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "4.c.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.1",
          global: true,
          children: [_jsx(_components.p, {
            children: "Доля учителей, обладающих минимальным уровнем организованной профессиональной подготовкой, в разбивке по уровням образования"
          }), _jsx(ThemeLabel, {
            theme: "quality",
            id: "4.c.1"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.c.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.2",
          children: [_jsx(_components.p, {
            children: "Соотношение учащийся/подготовленный учитель, в разбивке по уровням образования"
          }), _jsx(ThemeLabel, {
            theme: "quality",
            id: "4.c.2"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.c.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.3",
          children: _jsx(_components.p, {
            children: "Доля учителей, обладающих квалификацией согласно национальным стандартам, в разбивке по уровням образования и типам образовательных учреждений"
          })
        }), _jsx(IndicatorRow, {
          id: "4.c.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.4",
          children: _jsx(_components.p, {
            children: "Соотношение учащийся/квалифицированный учитель, в разбивке по уровням образования"
          })
        }), _jsx(IndicatorRow, {
          id: "4.c.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.5",
          children: _jsx(_components.p, {
            children: "Средняя зарплата учителя по отношению к другим профессиям, требующим сопоставимого уровня квалификации"
          })
        }), _jsx(IndicatorRow, {
          id: "4.c.6",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.6",
          children: _jsx(_components.p, {
            children: "Коэффициент текучести кадров среди учителей, в разбивке по уровням образования"
          })
        }), _jsx(IndicatorRow, {
          id: "4.c.7",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.7",
          children: _jsx(_components.p, {
            children: "Доля учителей, прошедших курс профессиональной подготовки без отрыва от работы в течение последних 12 месяцев, в разбивке по типам подготовки"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "финансирование",
        children: "Финансирование"
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=340",
          children: "См. последнюю версию главы Доклада ВДМО"
        })
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "F.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/govexp",
          children: [_jsx(_components.p, {
            children: "Государственные расходы на образование. % от ВВП"
          }), _jsx(ThemeLabel, {
            theme: "finance",
            id: "F.1"
          })]
        }), _jsxs(IndicatorRow, {
          id: "F.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t1.a/i1.a.2",
          children: [_jsx(_components.p, {
            children: "Расходы на образование в виде % от общей суммы государственных расходов"
          }), _jsx(ThemeLabel, {
            theme: "finance",
            id: "F.2"
          })]
        })]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
